import Swal from 'sweetalert2'
import { lang } from '../../assets/lang'
import { otnSingleHtml } from './otnSingleHtml'
import { sweetAlertCommonParams, createSelect2DynamicOption, selectedOptionsTextArray } from '../../utils/functions'

const base_url = window.xitFlowBuilderData.base_url
const page_table_id = window.xitFlowBuilderData.page_table_id
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

export const otnSingleModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.otn_single_modal_title,
    html: otnSingleHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })
      
      const templateNameElement = $('#template-name')
      templateNameElement.val(oldData.templateName || '')
      // not sure why this code is here
      // $('#action-button-messenger-engagement-languages').val(oldData.language || 'en_US').trigger('change')

      const elementLabel = $('#new-button-choose-label')
      const elementLabelRemove = $('#new-button-remove-label')
      createSelect2DynamicOption(elementLabel)
      createSelect2DynamicOption(elementLabelRemove)
      const buttonWebhookUrl = $('#new-button-webhook-url')
      buttonWebhookUrl.val(oldData.buttonWebhookUrl || '')

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
        dataType: 'JSON',
        data: { page_table_id, requested_from: 'new_postback', instagram_bot_addon },
        success:function(response) {
          $("#new-button-choose-label").html(response.label_dropdown);
          $("#new-button-remove-label").html(response.label_dropdown);
          $("#new-button-choose-sequence").html(response.drip_dropdown);
          $("#new-button-remove-sequence").html(response.drip_dropdown_remove);

          $('#new-button-choose-label').val(oldData.labelIds || '').trigger('change')
          $('#new-button-remove-label').val(oldData.labelIdsRemove || '').trigger('change')

          if (isSequenceAddonAvailable) {
            $('#new-button-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
            $('#new-button-remove-sequence').val(oldData.sequenceIdValueRemove || '').trigger('change')
          }
        }
      })

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_team_and_user',
        dataType: 'JSON',
        data: { page_table_id },
        success:function(response) {
          $("#new-button-conversation-user").html(response.team_dropdown);
          $('#new-button-conversation-user').val(oldData.conversationUserId || '').trigger('change')
          $("#new-button-conversation-group").html(response.role_dropdown);
          $('#new-button-conversation-group').val(oldData.conversationGroupId || '').trigger('change')
        }
      })


    },

    preConfirm: () => {
      const templateName = $('#template-name').val()
      if (! templateName) {
        Swal.showValidationMessage(lang.otn_single_modal_template_name_msg)
      }
      const buttonWebhookUrl = $('#new-button-webhook-url').val()

      const data = {
        templateName,
        buttonWebhookUrl
      }

      const labelIds = $('#new-button-choose-label').val()
      const labelIdTexts = $('#new-button-choose-label option:selected')      
      const labelIdTextsArray = selectedOptionsTextArray(labelIdTexts) 
      data['labelIds'] = labelIds
      data['labelIdTextsArray'] = labelIdTextsArray

      const labelIdsRemove = $('#new-button-remove-label').val()
      const labelIdTextsRemove = $('#new-button-remove-label option:selected')      
      const labelIdTextsArrayRemove = selectedOptionsTextArray(labelIdTextsRemove) 
      data['labelIdsRemove'] = labelIdsRemove
      data['labelIdTextsArrayRemove'] = labelIdTextsArrayRemove
      
      if (isSequenceAddonAvailable) {
        const sequenceIdValue = $('#new-button-choose-sequence').val()
        const sequenceIdText = $('#new-button-choose-sequence option:selected').text()
        data['sequenceIdValue'] = sequenceIdValue
        data['sequenceIdText'] = sequenceIdText

        const sequenceIdValueRemove = $('#new-button-remove-sequence').val()
        const sequenceIdTextRemove = $('#new-button-remove-sequence option:selected').text()
        data['sequenceIdValueRemove'] = sequenceIdValueRemove
        data['sequenceIdTextRemove'] = sequenceIdTextRemove
      }

      const conversationGroupId = $('#new-button-conversation-group').val()
      const conversationGroupText = $('#new-button-conversation-group option:selected').text()
      data['conversationGroupId'] = conversationGroupId
      data['conversationGroupText'] = conversationGroupText

      const conversationUserId = $('#new-button-conversation-user').val()
      const conversationUserText = $('#new-button-conversation-user option:selected').text()
      data['conversationUserId'] = conversationUserId
      data['conversationUserText'] = conversationUserText

      return data
    },
  })
}